<template>
	<section class="hero">
		<GlobalImage class="hero__line hero__line--1" src="locations-hero-line1.png" alt="Locations hero line 1" :height="270" />
		<GlobalImage class="hero__line hero__line--2" src="locations-hero-line2.png" alt="Locations hero line 2" :height="178" />
		<GlobalImage class="hero__line hero__line--3" src="locations-hero-line3.png" alt="Locations hero line 3" :height="580" />
		<div class="hero__container" data-aos="fade-up">
			<GlobalImage class="hero__map" alt="Locations hero map" src="locations-hero-map-v3.png" :width="513" />
			<GlobalImage class="hero__map hero__map--mobile" alt="Locations hero map mobile" src="location-hero-map-mobile.png" :width="718" />
			<div class="hero__container-title">
				<h1 class="hero__title">{{ $t('modules.locations_page_module.locations_page_hero.over_119_locations') }}</h1>
				<p class="hero__subtitle">{{ $t('modules.locations_page_module.locations_page_hero.deliver_car_to_your_door') }}</p>
				<button class="hero__search-btn" @click="handleOpen">
					<span>{{ $t('modules.locations_page_module.locations_page_hero.enter_address_or_city') }}</span>
					<div class="hero__search-btn-icon">
						<GlobalIcon name="search-normal" :width="20" />
					</div>
				</button>
			</div>
			<GlobalDepartmentsSearchList v-click-outside="onClickOutside" :scroll="true" />
		</div>
	</section>
</template>

<script setup lang="ts">
const openedList = ref(false)
const openingList = ref(false)
provide('openedList', openedList)

const handleOpen = () => {
	openedList.value = !openedList.value
	openingList.value = true
	setTimeout(() => {
		openingList.value = false
	}, 10)
}

const onClickOutside = () => {
	if (openedList.value && !openingList.value) {
		openedList.value = false
	}
}
</script>

<style scoped lang="scss">
@import './LocationsPageHero.scss';
</style>
